import React from 'react'

function Navbar(){
    return (
        <nav className="navbar navbar-dark bg-dark mb-5">
            <span className="navbar-brand mb-0 h1 mx-auto">Lyric Finders</span>
        </nav>


    )
}
export default Navbar;